// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__sa6zB","decorated-wrapper":"Header_decorated-wrapper__WF08X","header":"Header_header__z73Oo","flex":"Header_flex__3qZW5","content":"Header_content__5BqJB"};